import DownloadIcon from '@mui/icons-material/Download';
import {
  Alert, LinearProgress, Snackbar, Typography, useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { ExportTranscriptionContext } from '../../context';

const DownloadProgressAlert = (): JSX.Element => {
  const { t } = useTranslation();
  const { isDownloadingExportFile } = useContext(ExportTranscriptionContext);
  const theme = useTheme();
  if (isDownloadingExportFile) {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open
        style={{
          top: '8em',
        }}
      >
        <Alert
          severity="info"
          icon={(
            <DownloadIcon
              style={{
                color: theme.palette.primary.main,
                margin: '5px 0',
              }}
            />
          )}
        >
          <Typography>{t('home.songbook.download')}</Typography>
          <LinearProgress style={{ width: '100%' }} color="primary" />
        </Alert>
      </Snackbar>
    );
  }
  return null;
};

export default DownloadProgressAlert;
